import useImage from 'use-image'
import { Image as KImage } from 'react-konva'
import useIsMobile from '@/hooks/use-is-mobile'

const ContractImage = ({ url, i, dimensions }) => {
  const isMobile = useIsMobile()
  const [image] = useImage(url)
  return (
    <KImage
      key={i}
      id={`page-${i}`}
      name="image"
      image={image}
      width={dimensions?.resizedWidth}
      height={dimensions?.resizedHeight}
      x={0}
      y={0}
      visible={i === 0 ? true : false}
      preventDefault={isMobile ? false : true}
    />
  )
}

export default ContractImage
